import { PluginFunction } from 'vue';
import { AlertOptions } from './AlertOptions';
import AlertInterface from './interface';

const Plugin: PluginFunction<AlertOptions> = (Vue, options) => {
  const alert = AlertInterface(Vue, options);
  window.$alert = alert;
  Vue.$alert = alert;
  Vue.prototype.$alert = alert;
}

export { Alert } from './Alert';
export { AlertOptions } from './AlertOptions';
export { AlertInterface };

export default Plugin;